import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'About',
    href: '/about'
  }, {
    name: 'Services',
    href: '/services'
  }, {
    name: 'Insights',
    href: '/insights'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  // Use a transparent header only over the dark Home hero. Every other route
  // begins with a light navigation surface for consistent readability.
  const isHome = location.pathname === '/';
  const isWhiteHeader = isScrolled || !isHome;
  const navStyle = isWhiteHeader ? 'bg-brand-warm-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent pt-3 pb-7';
  const textStyle = isWhiteHeader ? 'text-brand-navy hover:text-brand-gold' : 'text-white hover:text-brand-gold';
  const logoStyle = isWhiteHeader ? '' : 'invert brightness-0';
  const logoSrc = 'https://cdn.magicpatterns.com/uploads/7fqogpQfYe6LJMG1Tmc1x4/ChatGPT_Image_Jul_13,_2026,_06_34_58_PM.png';
  return <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${navStyle}`} data-id="element-69">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-70">
        <Link to="/" className="flex items-center gap-2" data-id="element-71">
          <img src={logoSrc} alt="Consilium Advisory Logo" className={`h-24 w-auto object-contain transition-all duration-500 ${logoStyle}`} data-id="element-72" />
        </Link>

        <div className="hidden md:flex items-center gap-8" data-id="element-73">
          {navLinks.map(link => {
          const isActive = location.pathname === link.href;
          return <Link key={link.name} to={link.href} className={`text-[11px] font-bold tracking-[0.15em] uppercase transition-all duration-300 relative group ${isActive ? 'text-brand-gold' : textStyle}`} data-id="element-74">
                {link.name}
                <span className={`absolute -bottom-1 left-0 h-[1.5px] bg-brand-gold transition-all duration-300 ${isActive ? 'w-full' : 'w-0 group-hover:w-full'}`} data-id="element-75" />
              </Link>;
        })}
        </div>

        <div className="hidden md:block" data-id="element-76">
          <Link to="/contact" data-id="element-77">
            <button className="bg-brand-gold hover:bg-brand-gold/90 text-white px-6 py-3 text-sm font-semibold tracking-wider uppercase transition-all" data-id="element-78">
              Schedule a Consultation
            </button>
          </Link>
        </div>

        <button className="md:hidden text-brand-navy" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-79">
          {isMobileMenuOpen ? <X size={28} data-id="element-80" /> : <Menu size={28} className={isScrolled || !isHome ? 'text-brand-navy' : 'text-white'} data-id="element-81" />}
        </button>
      </div>

      <AnimatePresence data-id="element-82">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 w-full bg-brand-warm-white shadow-xl py-8 px-6 md:hidden" data-id="element-83">
            <div className="flex flex-col gap-6" data-id="element-84">
              {navLinks.map(link => <Link key={link.name} to={link.href} className="text-lg font-heading font-semibold text-brand-navy" onClick={() => setIsMobileMenuOpen(false)} data-id="element-85">
                  {link.name}
                </Link>)}
              <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)} data-id="element-86">
                <button className="w-full bg-brand-gold text-white px-6 py-4 text-sm font-semibold tracking-wider uppercase" data-id="element-87">
                  Schedule a Consultation
                </button>
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
};